/*
  Separating out the context file will prevent circular dependencies for the imports
*/

import React from 'react';

export interface CurrentUserContextData {
  currentUser?: CurrentUser;
  setCurrentUser: (currentUser: CurrentUser, token: string) => void;
  /**
   * Patches the signed in user without a fresh sign in.
   *
   * Some company settings are delivered on the user payload and read from it while the app runs, so
   * saving one has to write the new value back here — otherwise the app keeps acting on whatever was
   * true at login until the page is reloaded.
   */
  updateCurrentUser: (patch: Partial<CurrentUser>) => void;
  unsetCurrentUser: () => void;
}

export const CurrentUserContext = React.createContext<CurrentUserContextData>({
  setCurrentUser: () => {},
  updateCurrentUser: () => {},
  unsetCurrentUser: () => {}
});

export const CurrentUserProvider = CurrentUserContext.Provider;
export const CurrentUserConsumer = CurrentUserContext.Consumer;
